<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-objective === cco -->
      <div class="cco">
        <div class="cco-box custom-item">
          <!-- 内容 -->
          <!-- <img
            src="@assets/img/template/company-component-cove-5-1.jpg"
            width="100%"
            v-if="info.companyType === 1"
          />-->
          <div class="custom-m-item" v-if="info.companyType === 1">
            <div style="word-break: break-all; white-space: pre-wrap;">{{Modal.content}}</div>
            <div class="cmi-title">{{Modal.title || 'seek cooperation'}}</div>
            <div class="cmi-objective" v-if="Modal.content && Modal.content.length"> 

              <div v-for="(item, index) in Modal.content" :key="'object-' + index" class="cmi-objective-box"> 
                
                  <div class="cmio-line" v-if="item.typeId === 5">
                    <div class="cmio-line-left">{{item.key}}</div>
                    <div class="cmio-line-rigth">
                      <div class="brand" v-for="(item, index) in item.value" :key="`object-type-${item.typeId}-` + index">{{item}}</div> 
                    </div>
                  </div>
                  <div class="cmio-line2" v-if="item.typeId === 6">
                    <div class="cmio-line2-left">Sales region</div>
                    <div class="cmio-line2-rigth">
                      <div class="brand" v-for="(item, index) in item.value" :key="`object-type-${item.typeId}-` + index">{{item}}</div> 
                    </div>
                  </div> 
              </div>
              <div class="cmi-objective-box2">
                <div v-for="(item, index) in Modal.content" :key="'object2-' + index" class="cmio-line3" v-if="item.typeId === 9" >  
                    <div class="title">{{item.key}}</div>
                    <div class="info">{{item.value}}{{item.unit}}</div>  
                </div>
              </div>
            </div>
            </div>
            <!-- <img src="@assets/img/template/company-component-cove-6.jpg" width="100%" /> -->
          </div>
          <img
            src="@assets/img/template/company-component-cove-5-2.jpg"
            width="100%"
            v-if="info.companyType === 2"
          />
          <img
            src="@assets/img/template/company-component-cove-5-3.jpg"
            width="100%"
            v-if="info.companyType === 3"
          />
          <img
            src="@assets/img/template/company-component-cove-5-4.jpg"
            width="100%"
            v-if="info.companyType === 4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 寻求代理
  name: "custom-company-objective",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "寻求代理",
          type: 2,
          isOpen: true,
          title: "寻求代理",
          content: []
        };
      }
    }
  },
  data() {
    return {
      visible: false,
      visible2: false,
      pageSize: 6,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      activeIndex: "customCompanyModule/getActiveIndex"
    })
  },
  created() {},
  methods: {
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/partner/allpartner";
      window.open(link);
    },
    changeModal(e, i) {
      let copyValue = JSON.parse(JSON.stringify(this.Modal));
      copyValue.content[i].value = e;
      this.$emit("sendModal", copyValue);
    }
  }
};
</script> 
<style scoped lang="scss">
.cco {
  width: 100%;
  &-pop {
    padding: 20px;
    width: 250px;
  }
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ccop {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        position: relative;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  &-wrapper {
    padding-top: 20px;
    font-size: 14px;
    color: #333;
    &-box {
      display: flex;

      &__item {
        width: 100%;
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: solid 1px #bfbfbf;
        margin-bottom: 20px;
        position: relative;

        color: #fff;
        border-color: #fe781d;
        background: #fe781d;
        .icon-closec {
          position: absolute;
          color: red;
          top: -16px;
          right: -12px;
          font-size: 20px;
          cursor: pointer;
        }
        &.active {
          color: #fff;
          border-color: #fe781d;
          background: #fe781d;
        }
        p {
          width: calc(100% - 1px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      &__item2 {
        color: #1890ff;
        width: calc(100% - 1px);
        padding: 5px;
        text-align: center;
        border-radius: 5px;
        border: dashed 1px #1890ff;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        margin-bottom: 20px;
        &.disable {
          background-color: #f3f3f3;
          color: #ccc;
          border-color: #ccc;
        }
      }
    }
    &-label {
      line-height: 31px;
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
